export default __webpack_public_path__ + "images/localDefault.f69e4cece2ef6c473abc4efd2e5fa662.jpg";